module.exports = __webpack_public_path__ + "img/img30.1031165d.svg";